"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DialogContent", {
    enumerable: true,
    get: function() {
        return DialogContent;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDialogContent = require("./useDialogContent");
const _renderDialogContent = require("./renderDialogContent");
const _useDialogContentStylesstyles = require("./useDialogContentStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const DialogContent = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDialogContent.useDialogContent_unstable)(props, ref);
    (0, _useDialogContentStylesstyles.useDialogContentStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDialogContentStyles_unstable')(state);
    return (0, _renderDialogContent.renderDialogContent_unstable)(state);
});
DialogContent.displayName = 'DialogContent';
